export var DASHPASS_STATUS;
(function (DASHPASS_STATUS) {
    DASHPASS_STATUS["TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_UNSPECIFIED"] = "TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_UNSPECIFIED";
    DASHPASS_STATUS["TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_ACTIVE"] = "TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_ACTIVE";
    DASHPASS_STATUS["TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_INACTIVE"] = "TEAM_ACCOUNT_DASHPASS_SUBSCRIPTION_STATUS_INACTIVE";
})(DASHPASS_STATUS || (DASHPASS_STATUS = {}));
